/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (page, sortAttr, label, search) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  assignLabelToMultipleContacts(queryFilter, queryLabel, querySearch, label) {
    return axios.post(`${this.url}/assign_label_to_multiple_contacts`, { queryFilter, queryLabel, querySearch, label});
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.get(requestURL);
  }

  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  filterSearchIndex(payload){
    const {page, sortAttr, label, search, queryPayload} = payload;
    const requestURL = `${this.url}/filter_search_index?${buildContactParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.post(requestURL, queryPayload);
  }

  importContacts(payload) {
    const formData = new FormData();
    formData.append('import_file', payload.file);
    if(payload.dataType) {
      formData.append('data_type', payload.dataType);
    }
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts() {
    return axios.get(`${this.url}/export`);
  }

  getContracts(id) {
    return axios.get(`${this.url}/${id}/get_contract`);
  }

  block(contactId, blockReason) {
    return axios.post(`${this.url}/${contactId}/block`, {
      block_reason: blockReason,
    });
  }

  unblock(contactId) {
    return axios.post(`${this.url}/${contactId}/unblock`);
  }
}

export default new ContactAPI();
